/* eslint-disable @typescript-eslint/no-explicit-any */
import { post } from '_core/config/api/Api';
import { IFinalResponse } from '_core/types';
import Definitions from '../Definitions';

const definitions = Definitions.ValidateLegalGuardian;

const callPost = async (): Promise<IFinalResponse> => {
  return post(
    definitions.API_DOMAIN,
    definitions.ENDPOINT_API_PATH,
    definitions.API_CREDENTIALS_TYPE,
    {},
  );
};
const call = { post: callPost };
export default { call, definitions };
